import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { GetMetersArgs, GetMetersResponse } from 'lib/services';
import { type UseQueryOptions, type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { Sorter } from '../../../components/table/types/sorter';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useMeters = <T = GetMetersResponse>(
  { filter, populate, view }: GetMetersArgs,
  options: UseQueryOptions<T> = {},
): UseQueryResult<T> => {
  const notify = useAppNotifications();
  const {
    backendGateway: { meters },
  } = useServices();

  const parseSorting = (sort: Sorter) => (sort.order === 'ascend' ? sort.field : `-${sort.field}`);

  const parsedFilter = {
    ...filter,
    sorts: filter?.sorts?.map(parseSorting),
  };

  return useQuery({
    queryFn: async () => await meters.find<T>(parsedFilter, populate, view),
    queryKey: QUERY_KEYS.meters.filter(parsedFilter, populate, view),
    onError: error => {
      notify.error({
        message: 'There was an error while fetching meters',
        description: getErrorMessage(error),
      });
    },
    ...options,
  });
};
